{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description }}
{{/if}}

<div class="tool-field"></div>

<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
